<template>
    <v-img
        v-if="imageX"
        :src="imageX"
        max-height="700"
        aspect-ratio="1.0"
        :contain="image"
    >
    </v-img>
</template>

<script>
import security from "@/main";
import Img from "@/modules/img/components/service/Img";

export default {
    name: "ImgImage",

    props: {
        id: {

        },
        /** The entry of the folder's images; with the media service it carries the renditions. */
        item: {
            required: false,
        },
        image: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },

    data: () => ({
        imageX: null
    }),

    mounted () {
        const url = Img.imageUrl(this.item || this.id, this.image ? "view" : "thumb");
        if (!url) {
            return;
        }
        fetch(url, {method: "GET", headers: security.jsonHeader()})
            .then(response => {
                return response.blob().then(blob => {
                    const data = new Blob([blob], {type: response.headers.get("Content-Type")});
                    this.imageX = URL.createObjectURL(data);
                })
            });
    },
}
</script>

<style scoped>

</style>